import { CmsComponentMetadataComponent } from '../CmsComponentMetadataComponent';
import MagnoliaCmsComponentMetadataComponent from '../magnolia/dynamic-magnolia-cms-component-metadata.component';

function DefaultCmsComponentMetadataComponent(): null {
  return null;
}

const ConfigurableCmsComponentMetadata: CmsComponentMetadataComponent =
  process.env.NEXT_PUBLIC_CMS_METADATA_RENDER === 'magnolia'
    ? MagnoliaCmsComponentMetadataComponent
    : DefaultCmsComponentMetadataComponent;

export default ConfigurableCmsComponentMetadata;
